import {useQuery} from 'react-query'
import {EditModalForm} from './EditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getGuardiansFilter} from '../core/_requests'
import { GuardianStatus } from '../core/_models'

const EditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const {
    isLoading,
    data: category,
    error,
    status
  } = useQuery(
    `${QUERIES.GUARDIANS_LIST}-authors-${itemIdForUpdate}`,
    () => {
      return getGuardiansFilter({id: itemIdForUpdate, take: 0, skip: 1})
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <EditModalForm
        isAuthorsLoading={isLoading}
        response={{
          status_id: GuardianStatus.active.id,
          created_at: new Date(),
        }}
        status={status}
      />
    )
  }

  if (!isLoading && !error && category) {
    return (
      <EditModalForm
      isAuthorsLoading={isLoading}
        response={category?.data}
        status={status}
      />
    )
  }

  return null
}

export {EditModalFormWrapper}
